import { Injectable } from '@angular/core';

import { passageirosStorage } from "./data.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";

@Injectable()
export class PassageiroService {

    constructor(
        private _autocompleteService: AutoCompleteService
    ) { }

    //session
    setSessionStorage(item: any) {
        let object: string = JSON.stringify(item);
        sessionStorage.setItem(passageirosStorage + '-new', object);
    }

    getSessionStorage() {
        let item: string = sessionStorage.getItem(passageirosStorage + "-new");
        return JSON.parse(item);
    }

    returnToOtherForm(otherForm: string, Response: any) {

    }

    templateResult = (function(state: any, isCreateNew: boolean) {
        var stateReturn: any,
            text: string;

        if (state.loading) {
            stateReturn = state.text;
        } else {
            if (state.id === -1) {
                if (isCreateNew) {
                    stateReturn = this._autocompleteService.setNewTagInList(state);
                } else {
                    stateReturn = this._autocompleteService.setNoCreateNew(state.text);
                }
            } else {
                if (state.text) {
                    text = state.text;
                } else {
                    var name: string = state.nome;
                    text = name;
                }
                stateReturn = $('<span>' + text + '</span>');
            }
        }

        return stateReturn;
    }.bind(this));
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/passageiros/shared/passageiro.service.ts
 **/